import { boolean, json, pgTable, text, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { estates } from "./estate"
import { users } from "./users"

// Purpose: Stores responses to guided forms, which help collect structured estate planning data.
export const guidedForms = pgTable("guided_form", {
  id: uuid("id").primaryKey().defaultRandom(),
  estateId: uuid("estate_id")
    .notNull()
    .references(() => estates.id, { onDelete: "cascade" }),
  formDataJson: json("form_data_json").notNull(),
  percentageComplete: varchar("percentage_complete", { length: 10 }).notNull().default("0%"),
  executorCompensation: boolean("executor_compensation").default(false),
  isComplete: boolean("is_complete").default(false),
  businessOwnership: boolean("business_ownership").default(false),
  createTrust: boolean("create_trust").default(false),
  trustBond: boolean("trust_bond").default(false),
  willDescription: text("will_description"),
  completionDate: timestamp("completion_date"),
  completedByUserId: varchar("completed_by_user_id", { length: 255 }).references(() => users.id, {
    onDelete: "cascade",
  }),
  createdAt: timestamp("created_at").defaultNow().notNull(),
  // Note: For 'ON UPDATE CURRENT_TIMESTAMP' functionality in PostgreSQL,
  // a database trigger is required. This schema sets the timestamp on creation,
  // and application logic or a trigger should handle updates.
  updatedAt: timestamp("updated_at").defaultNow().notNull(),
})
